var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { Button } from 'reactstrap';
import { Label } from 'sdc-i18n-react';

import { WithHotkey } from '../hotkeys';

import './button.scss';

var TheToolbarButton = inject('labelsStore')(observer(function (_ref) {
  var labelsStore = _ref.labelsStore,
      icon = _ref.icon,
      caption = _ref.caption,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$hotkey = _ref.hotkey,
      hotkey = _ref$hotkey === undefined ? '' : _ref$hotkey,
      _ref$iconClassName = _ref.iconClassName,
      iconClassName = _ref$iconClassName === undefined ? '' : _ref$iconClassName,
      _ref$iconStyle = _ref.iconStyle,
      iconStyle = _ref$iconStyle === undefined ? {} : _ref$iconStyle,
      close = _ref.close,
      props = _objectWithoutProperties(_ref, ['labelsStore', 'icon', 'caption', 'title', 'hotkey', 'iconClassName', 'iconStyle', 'close']);

  return React.createElement(
    Button,
    _extends({ outline: true, size: 'sm' }, props, {
      title: labelsStore.labelFor(title, props) + (hotkey ? ' [' + hotkey + ']' : '') }),
    icon && React.createElement('i', { className: iconClassName + ' fa fa-fw fa-' + icon, style: iconStyle }),
    caption && React.createElement(
      'span',
      { className: 'caption' },
      React.createElement(Label, { value: caption })
    ),
    close && React.createElement('i', { className: 'fa fa-fw fa-times' })
  );
}));

export var ToolbarButton = function ToolbarButton(props) {
  return React.createElement(WithHotkey, _extends({}, props, {
    render: function render(props) {
      return React.createElement(TheToolbarButton, props);
    } }));
};